export { default } from '../src/pages/Page'
